<template>
  <div class="component-name is-flex-col">
    <span>{{ text }}</span>
    <span class="text-gray is-size-7">{{ helper }}</span>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: ['choice'],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    hasHelper() {
      return (typeof choice) === 'object';
    },
    text() {
      const val = this.choice.text;
      return (val ? val : this.choice);
    },
    helper() {
      return this.choice.helper;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
  },
};
</script>


<style scoped>

</style>
